import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../redux/mobileSpecificBehaviour/actions.mobileSpecificBehaviour';
import store from '../../../store';
import history from '../../../history';
import { routeInfo } from '../../../routeInfo';

class MobileWarningBanner extends React.Component {

    componentDidMount() {
        this.checkForMobile();
    }

    componentDidUpdate() {
        this.checkForMobile();
    }

    checkForMobile() {
        const mobileRoutes = [
            'login',
            routeInfo.githubOauth.path,
            'loginWithGithub',
            'oauth',
            'register',
            'registered',
            'verificationEmailSent',
            'restorePassword',
            'recovery',
            'billing/new'
        ];

        const currentRoute = history.getCurrentLocation().pathname;

        if (!mobileRoutes.includes(currentRoute)) {
            store.dispatch(actions.showMobileWarning());
        }
    }

    render() {
        const {
            isMobileWarningShown,
            hideMobileWarning
        } = this.props;

        return <div className={`mobile-warning-banner ${isMobileWarningShown && 'shown'}`}>
            <i className="icon icon-alan-remove" onClick={hideMobileWarning}></i>
            The Alan AI Studio functionality is limited on mobile. Use Alan AI Studio within a desktop browser for a better experience
    </div>;
    }
}

function mapStateToProps(state, ownProps) {
    return {
        isMobileWarningShown: state.mobileSpecificBehaviour.isMobileWarningShown,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        hideMobileWarning: () => dispatch(actions.hideMobileWarning()),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MobileWarningBanner);
